import http from "../utils/http";

export const addEditorTemplate = (body = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/editor/template', body)
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getEditorTemplateList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/editor/template/list', params)
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};


export const getEditorTemplate = (idx) => {
  return new Promise((resolve, reject) => {
    http.get(`/editor/template/${idx}`)
      .then(data => {
        resolve(data.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const editEditorTemplate = (idx, body) => {
  return new Promise((resolve, reject) => {
    http.put(`/editor/template/${idx}`, body)
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteEditorTemplate = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/editor/template`, { data })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};